/**
 * API path helper: when REACT_APP_API_URL is set (e.g. http://localhost:8788),
 * all requests go there so `npm start` on :3000 and `wrangler pages dev` on :8788
 * share the same Workers + KV. Otherwise paths stay same-origin relative.
 *
 * @param {string} path - Absolute path beginning with /
 * @returns {string}
 */
export function apiUrl(path) {
  const raw =
    typeof process !== 'undefined' && process.env.REACT_APP_API_URL
      ? String(process.env.REACT_APP_API_URL).trim()
      : '';
  const base = raw.replace(/\/+$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base}${p}` : p;
}
